import { render, staticRenderFns } from "./AutocompleteSuggestions.vue?vue&type=template&id=34a904a8&scoped=true&lang=html&"
import script from "./AutocompleteSuggestions.vue?vue&type=script&lang=js&"
export * from "./AutocompleteSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./AutocompleteSuggestions.vue?vue&type=style&index=0&id=34a904a8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a904a8",
  null
  
)

export default component.exports